export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-200">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-base"></i>
              </span>
              <span className="text-lg font-bold text-background-50">51视频</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              51视频提供高清免费在线观影服务，电影、电视剧、综艺、动漫、纪录片一网打尽，播放流畅不卡顿，免费在线观看全集。
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-2">
              {[
                { label: '热门视频', href: '#media' },
                { label: '热度榜单', href: '#ranking' },
                { label: '专题合集', href: '#index' },
                { label: '常见问题', href: '#faq' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">关于</h3>
            <ul className="space-y-2">
              {[
                { label: '关于我们', href: '#about' },
                { label: '联系我们', href: '#contact' },
                { label: '最新动态', href: '#updates' },
                { label: '用户评价', href: '#comments' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Partners */}
          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-500">合作伙伴信息敬请期待</p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <span className="text-xs text-background-500">
            &copy; 2025 51视频. 本站所有内容仅供学习交流使用.
          </span>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-500 hover:text-accent-400 transition-colors">回到顶部</a>
            <span className="text-xs text-background-500">高清免费 · 在线观看 · 不卡顿</span>
          </div>
        </div>
      </div>
    </footer>
  );
}